import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getPlanNearbyListingsInfo } from 'constants/routes'
import { combineAndSortListings } from '../services/processSummaryCard';

/**
 * Retrieves additional information for a plan nearby listings carousel.
 * @param {Object} payload - The payload containing the plan Id.
 * @param {string} payload.id - The ID of the marker.
 * @returns {Observable} - An observable that emits the additional marker information.
 */
function getPlanNearbyListings(payload) {
  const url = `${getPlanNearbyListingsInfo}?plans=${payload.planIds}&specs=${payload.specIds}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'image/webp',
    }
  }).pipe(
    switchMap(async (response) => {
      const data = await response.json();
      const sortedListings = combineAndSortListings(data, payload.sortOrder);

      return sortedListings;
      
    })
  );
}

export default getPlanNearbyListings;